import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
    faPlay, 
    faPause, 
    faSearch, 
    faFilePowerpoint, 
    faVolumeMute, 
    faVolumeUp, 
    faVolumeDown, 
    faCompressArrowsAlt, 
    faExpand, 
    faCheck, 
    faTimes, 
    faWindowMinimize, 
    faSquare, 
    faLongArrowAltRight, 
    faChevronDown, 
    faChevronUp, 
    faArrowAltCircleDown,
    faUser,
    faExternalLinkAlt,
    faQuestionCircle,
    faCaretRight,
    faCaretLeft
} from '@fortawesome/free-solid-svg-icons'

import {
    faTimesCircle
} from '@fortawesome/free-regular-svg-icons'

library.add(faPlay)
library.add(faPause)
library.add(faSearch)
library.add(faFilePowerpoint)
library.add(faVolumeMute)
library.add(faVolumeUp)
library.add(faVolumeDown)
library.add(faCompressArrowsAlt)
library.add(faExpand)
library.add(faCheck)
library.add(faTimes)
library.add(faWindowMinimize)
library.add(faSquare)
library.add(faLongArrowAltRight)
library.add(faCaretRight)
library.add(faCaretLeft)
library.add(faChevronUp)
library.add(faChevronDown)
library.add(faArrowAltCircleDown)
library.add(faUser)
library.add(faExternalLinkAlt)
library.add(faQuestionCircle)
library.add(faTimesCircle)

Vue.component('fa-icon', FontAwesomeIcon)


import PlayCircleIcon from 'vue-material-design-icons/PlayCircle.vue';
import PauseCircleIcon from 'vue-material-design-icons/PauseCircle.vue';
import WebIcon from 'vue-material-design-icons/Web.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';


Vue.component('play-icon', PlayCircleIcon);
Vue.component('pause-icon', PauseCircleIcon);
Vue.component('web-icon', WebIcon);
Vue.component('close-icon', CloseIcon);

